import type { CalendarEventsResponse } from "@site-types/calendar"
import { type CSSProperties, useEffect } from "react"
import OptimizedImage from "../OptimizedImage"

const EVENT_CARD_CLASS =
  "event flex w-full translate-y-0 items-center justify-center bg-[var(--white)] p-0 leading-none shadow-[8px_8px_0_var(--blue-50)] transition-[scale,box-shadow] duration-100 ease-out [grid-row-end:span_4]"

function eventPlacementClassName(index: number) {
  return [
    index % 2 === 0 ? "col-start-2" : "col-start-1",
    index === 0 ? "row-start-1" : "",
    index === 1 ? "row-start-2" : "",
    index % 3 === 0 ? "calendar:col-start-3" : "",
    index % 3 === 1 ? "calendar:col-start-2" : "",
    index % 3 === 2 ? "calendar:col-start-1" : "",
    index === 2 ? "calendar:row-start-3" : "",
    index % 4 === 0 ? "calendar-wide:col-start-4" : "",
    index % 4 === 1 ? "calendar-wide:col-start-3" : "",
    index % 4 === 2 ? "calendar-wide:col-start-2" : "",
    index % 4 === 3 ? "calendar-wide:col-start-1" : "",
    index === 3 ? "calendar-wide:row-start-4" : "",
  ]
    .filter(Boolean)
    .join(" ")
}

const Events = (events: CalendarEventsResponse) => {
  useEffect(() => {
    const shipElement = document.querySelector("#ship")
    if (shipElement) {
      shipElement.classList.remove("place-center")
      shipElement.classList.add("place-back")
    }
  }, [])

  return (
    <div
      data-id="events-list"
      className="mx-auto my-[20px] grid w-[calc(100%_-_40px)] max-w-[1300px] calendar-wide:grid-cols-4 calendar:grid-cols-3 grid-cols-2 gap-y-[20px] calendar-wide:pb-[80px] text-center [column-gap:5%] calendar-narrow:[column-gap:20px]"
    >
      {events.totalCount > 0 &&
        events.results.map((event, index) => (
          <div
            className={`${EVENT_CARD_CLASS} [animation:slideUp_0.4s_cubic-bezier(0.19,1,0.22,1)_calc(var(--i,0)*100ms)_both] hover:scale-[0.98] hover:cursor-pointer hover:shadow-[4px_4px_0_var(--blue-50)] active:scale-[1.02] active:shadow-[8px_10px_0_var(--blue-50)] [&.hit-shake]:[animation:hitShake_0.4s_cubic-bezier(0.36,0.07,0.19,0.97)_both] ${eventPlacementClassName(index)}`}
            data-id={`event-${index}`}
            style={{ "--i": index } as CSSProperties}
            data-order={index}
            key={`event_${index}`}
          >
            <a
              href={event.taiyoroUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="aspect-video w-full bg-[var(--green)]"
            >
              <OptimizedImage
                draggable={false}
                src={event.imageUrl || event?.games?.[0]?.primaryImage}
                alt={event.name}
                width={640}
                height={360}
                className="block h-full w-full bg-[var(--pink)] text-[var(--white)]"
              />
            </a>
          </div>
        ))}
    </div>
  )
}

export default Events
